import { render, staticRenderFns } from "./BasePicture.vue?vue&type=template&id=402e3fc4&scoped=true&"
import script from "./BasePicture.vue?vue&type=script&lang=ts&"
export * from "./BasePicture.vue?vue&type=script&lang=ts&"
import style0 from "./BasePicture.vue?vue&type=style&index=0&id=402e3fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e3fc4",
  null
  
)

export default component.exports